

import state from './moduleWilayahState.js'
import mutations from './moduleWilayahMutations.js'
import actions from './moduleWilayahActions.js'
import getters from './moduleWilayahGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
